import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getCookie } from "typescript-cookie";
import { UserSession } from "../../types/Usuario/UserSession";
import { decodeTokenCast, expirationTokenAuth } from "../../utils/jwtUtils";
import { GetVoidLoggedUser, LoggedUser, mapTokenData } from "../../types/Usuario/LoggedUser";

const initialState: UserSession = {
    isAuth: 
     getCookie('tokenEspolAds') !== undefined
      ? !expirationTokenAuth(getCookie('tokenEspolAds')??'')
      : false,
    token: getCookie('tokenEspolAds') !== undefined && !expirationTokenAuth(getCookie('tokenEspolAds')??'') ? getCookie('tokenEspolAds') : '',
    userData: getCookie('tokenEspolAds') !== undefined && !expirationTokenAuth(getCookie('tokenEspolAds')??'') ? mapTokenData(decodeTokenCast<LoggedUser>(getCookie('tokenEspolAds')??''),getCookie('tokenEspolAds')??'') : GetVoidLoggedUser(),
    isLoading: getCookie('tokenEspolAds') === undefined, 
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        inUser: (state, action: PayloadAction<UserSession>) => {
            const {token, userData} = action.payload;
            // console.log(userData);
            if(token){
             state.isAuth = true;
             state.token = token;
             state.userData = userData;
             state.isLoading = false;
            }
        },
        outUser: (state) => {
            state.isAuth = false;
            state.token = '';
            state.userData = GetVoidLoggedUser();
        },
    }
})

export const{ inUser, outUser } = authSlice.actions;

